import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const SettingsAPI = {
  get: () => axiosInstance.get(API_ROUTES.SETTINGS.GET),
  update: (data) => axiosInstance.post(API_ROUTES.SETTINGS.UPDATE, data),
};
